import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const DeleteShiftDialog = ({
  open,
  patrolCount,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmberIcon sx={{ color: 'error.main' }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Delete Entire Shift
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography color="text.secondary">
          You are about to delete <strong>{patrolCount} patrol{patrolCount !== 1 ? 's' : ''}</strong> from this shift.
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          This action cannot be undone. Are you sure you want to continue?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Delete {patrolCount} Patrol{patrolCount !== 1 ? 's' : ''}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteShiftDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  patrolCount: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default memo(DeleteShiftDialog);
